// Only gateway/ingress failures justify route recovery, never application errors.
export function isRouteGatewayFailure(status: number) {
  return [502, 503, 504, 520, 521, 522, 523, 524, 525, 526, 530].includes(status)
}
